"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitionOut = exports.transitionIn = exports.changeExit = exports.clearRoute = exports.DefaultRoute = exports.BUILD_FLOW = exports.TRANSITION_FADE_IN = exports.TRANSITION_FADE_OUT = exports.CHANGE_EXIT = exports.CLEAR_ROUTE = exports.CHANGE_ROUTE = void 0;
exports.CHANGE_ROUTE = "CHANGE_ROUTE";
exports.CLEAR_ROUTE = "CLEAR_ROUTE";
exports.CHANGE_EXIT = "CHANGE_EXIT";
exports.TRANSITION_FADE_OUT = "TRANSITION_FADE_OUT";
exports.TRANSITION_FADE_IN = "TRANSITION_FADE_IN";
exports.BUILD_FLOW = "BUILD_FLOW";
exports.DefaultRoute = {
    enter: {
        overpanel: false,
        view: "",
        slide: 0,
        params: null,
        query: null,
    },
    exit: null,
    isFlow: false,
    transition: "",
};
function changeRoute(route) {
    if (route === void 0) { route = exports.DefaultRoute; }
    return {
        type: [exports.CHANGE_ROUTE],
        route: route,
    };
}
exports.default = changeRoute;
function clearRoute(route) {
    if (route === void 0) { route = exports.DefaultRoute; }
    return {
        type: [exports.CLEAR_ROUTE],
        route: {
            enter: {},
            exit: {},
        },
    };
}
exports.clearRoute = clearRoute;
function changeExit(route) {
    return {
        type: [exports.CHANGE_EXIT],
        route: {
            enter: route.enter,
            isFlow: route.isFlow,
        },
    };
}
exports.changeExit = changeExit;
function transitionIn() {
    return {
        type: [exports.TRANSITION_FADE_IN],
    };
}
exports.transitionIn = transitionIn;
function transitionOut() {
    return {
        type: [exports.TRANSITION_FADE_OUT],
    };
}
exports.transitionOut = transitionOut;
